import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { nextRoute } from "@/pages/Auth";
import { toast } from "sonner";

export function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    window.history.replaceState(null, "", location.pathname);
    if (!sessionId) { nav("/auth", { replace: true }); return; }
    api.post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => { setUser(data); nav(nextRoute(data), { replace: true }); })
      .catch((e) => { toast.error(apiError(e)); setUser(false); nav("/auth", { replace: true }); });
  }, [location, nav, setUser]);

  return <div className="min-h-screen flex items-center justify-center text-slate-400 font-mono text-sm" data-testid="auth-callback">Signing you in…</div>;
}
